import { LitElement, html, Splide } from '@hh/global.js'

export class HHCollectionProductListing extends LitElement {
  static properties = {
    slider: { state: true },
  }

  constructor() {
    super()
    this.maxProducts = this.dataset.maxProducts || 12
  }

  connectedCallback() {
    super.connectedCallback()
    const slider = this.querySelector('.splide')

    if (slider) {
      this.initSlider(slider)
    }
  }

  getSlideMaxAdjustment() {
    const sliderWidth = this.clientWidth
    const sliderSize = Number(this.dataset.sliderSize ?? 0)

    const calcWidthElm = this.querySelector('[data-splide-slide]')
    const slideWidth = calcWidthElm?.clientWidth ?? 0
    const computedWidth = Number(
      window.getComputedStyle(calcWidthElm)?.width?.replace('px', '') ?? 0
    )
    const widthToUse = slideWidth || computedWidth

    const slidesInView = Math.floor(sliderWidth / widthToUse)
    const adjustedIndex = sliderSize - slidesInView + 1

    return adjustedIndex
  }

  initSlider(slider) {
    this.slider = new Splide(slider, {
      type: 'slide',
      arrows: false,
      autoplay: false,
      autoWidth: true,
      gap: '0.8rem',
      direction: 'rtl',
      start: this.maxProducts,
      breakpoints: {
        475: {
          arrows: true,
          autoplay: false,
          autoWidth: true,
          gap: '0.8rem',
          direction: 'ltr',
          start: 0,
          pagination: false,
        },
      },
    })

    this.slider.mount()

    const prevButton = this.querySelector('[data-prev-button]')
    const nextButton = this.querySelector('[data-next-button]')
    prevButton?.setAttribute(
      'aria-label',
      `${prevButton.getAttribute('data-slide-title') ?? ''}, Previous Slide`
    )
    nextButton?.setAttribute(
      'aria-label',
      `${nextButton.getAttribute('data-slide-title') ?? ''}, Next Slide`
    )

    this.slider.on('move', () => {
      const sliderIndex = this.slider.index
      if (this.getSlideMaxAdjustment() === sliderIndex) {
        this.querySelector('[data-next-button]').classList.add('hidden')
      } else {
        this.querySelector('[data-next-button]').classList.remove('hidden')
      }
      if (sliderIndex > this.getSlideMaxAdjustment()) {
        this.slider.go(this.getSlideMaxAdjustment(), false)
      }
    })
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('collection-product-listing', HHCollectionProductListing)
